import Translate from "../../../common/translate/Translate";
import ParseUtil from "../../../common/utils/ParseUtil";
import { InfoTable } from "../../../common/components/table/InfoTable";
import { useState } from "react";
import DeviceHistoryModal from "../../store/modals/DeviceHistoryModal";

const InfoTableTitles = {
    deviceNumber: Translate("common.deviceInfo.deviceNumber"),
    type: Translate("common.deviceInfo.type"),
    model: Translate("common.deviceInfo.model"),
    deviceId: Translate("common.deviceInfo.deviceId"),
    detail: "Detail",
};

export default function TicketDeviceInfoTable({ device, currentDevice }) {
    const [isOpenHistoryModal, setIsOpenHistoryModal] = useState(false);

    let infoArray = ParseUtil.parseObjectToInfoTableArray(device, InfoTableTitles);
    if (typeof infoArray === "object" && device.deviceId !== "-") {
        infoArray = infoArray.map((item) => {
            if (item?.title === "Detail") {
                return {
                    title: item.title,
                    value: "detail",
                    isLink: true,
                    onClick: () => setIsOpenHistoryModal(true),
                };
            }
            return item;
        });
    }

    return (
        <>
            <InfoTable data={infoArray} />
            <DeviceHistoryModal
                device={device}
                isOpen={isOpenHistoryModal}
                onClose={() => setIsOpenHistoryModal(false)}
                isSecondaryModal={true}
                currentDevice={currentDevice}
            />
        </>
    );
}
